import { useMsal } from '@azure/msal-react';
import { ODSColumn, ODSGrid } from '@telekom-ods/react-ui-kit';
import { Suspense, lazy, useCallback } from 'react';

import { loginRequest } from '../../auth/msalConfig';
import { resolveNotificationTarget } from '../../helpers/notificationTargets';
import { useUserData } from '../../redux/selectors';
import SideNavigationMain from '../SidebarNavigation/SideNavigationMain';

import useAuth from './hooks/useAuth';
import useNotificationEvents from './hooks/useNotificationEvents';
import useNotificationNavigate from './hooks/useNotificationNavigate';
import PageContent from './PageContent';
import RemoteBoundary from './RemoteBoundary';

const NotificationMFProvider = lazy(
  () => import('notificationMicrofrontend/NotificationMFProvider')
);
const NOTIFICATION_API_BASE = import.meta.env.VITE_NOTIFICATION_V1_BASE ?? '/notifications/api/v1';

const Layout = () => {
  const { authenticated } = useAuth();
  const { instance } = useMsal();
  const user = useUserData();

  const getNotificationAccessToken = useCallback(async (): Promise<string | undefined> => {
    const account = instance.getActiveAccount();
    if (!account) return undefined;
    const result = await instance.acquireTokenSilent({ ...loginRequest, account });
    return result.accessToken;
  }, [instance]);

  const handleNavigate = useNotificationNavigate();
  const handleNotification = useNotificationEvents();

  return (
    <ODSGrid columns={14}>
      {authenticated ? (
        <RemoteBoundary
          name='NotificationMFProvider'
          microfrontend='notification-mf'
        >
          <Suspense fallback={null}>
            <NotificationMFProvider
              apiBaseUrl={NOTIFICATION_API_BASE}
              enableSse
              getAccessToken={getNotificationAccessToken}
              onNavigate={handleNavigate}
              resolveTarget={resolveNotificationTarget}
              onNotification={handleNotification}
              locale={user.locale ?? 'en'}
            />
          </Suspense>
        </RemoteBoundary>
      ) : null}
      <div
        className='container'
        style={{
          display: 'flex',
          flexDirection: 'row',
          height: '100vh',
          overflow: 'auto',
        }}
      >
        <ODSColumn
          style={{
            position: 'sticky',
            top: 0,
            alignSelf: 'flex-start',
            height: '100vh',
            flexShrink: 0,
            zIndex: 10,
          }}
        >
          <SideNavigationMain authenticated={authenticated} />
        </ODSColumn>
        <PageContent />
      </div>
    </ODSGrid>
  );
};

export default Layout;
